import { QuotationInfoInput } from '@e-socna/data-layer';
import type { ReadonlyDeep } from 'type-fest';

import { pruneInput } from '../../../utils/prune-input.util';
import { quotationHeaderForm2ApiMapper } from '../../../forms/QuotationHeader/mappers/quotation-header.form2api.mapper';

import type { MissionQuotationPage_QuotationInfo } from '../fragments/quotation-info.fragment';

export function quotationInfoForm2ApiMapper(
  quotationInfo: ReadonlyDeep<MissionQuotationPage_QuotationInfo>,
) {
  const quotationInfoInput = pruneInput(quotationInfo, QuotationInfoInput);
  return {
    ...quotationInfoInput,
    header: quotationHeaderForm2ApiMapper(quotationInfo.header),
  };
}
